export default __webpack_public_path__ + "static/media/cn.ddc8c3f6.svg";